// extracted by mini-css-extract-plugin
export default {"errorContainer":"AppRoutes-module__errorContainer--AvH54","logoutButton":"AppRoutes-module__logoutButton--lJuuW"};